// ========== Imports ==========
import { formatDate } from 'helpers/StringNumberFunction/formatDate';
import { moneyFunction } from 'helpers/StringNumberFunction/moneyFunction';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';

// ========== Component ==========
export const ELetterServiceSubcontract = ({
  docType,
  previewDetail,
  allpreviewDetail,
  getSubcontract,
  paramVal,
  ItemIndex,
}) => {
  // ========== Get Company Details from local storage ==========
  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
  // CX-5524: [companyCurrencyCode] previously read a dead previewDetail.user chain
  const loggedInUser = JSON.parse(localStorage.getItem('loggedInUser'));

  const subcontractData = previewDetail?.info || previewDetail;

  const getTradeData = (index = 0) => {
    const isMultipleTrade = subcontractData?.multipleTrade;

    if (isMultipleTrade) {
      const tradeWbs = subcontractData?.subcontractCostWbs?.[index];
      return {
        name: tradeWbs?.costCategory?.name ?? '',
        tradeAmt: tradeWbs?.tradeAmt ?? 0,
        revisedTradeAmt: tradeWbs?.revisedTradeAmt ?? tradeWbs?.tradeAmt ?? 0,
        tradeVoAmt: tradeWbs?.tradeVoAmt ?? 0,
      };
    } else {
      return {
        name: subcontractData?.tradeDetail?.name ?? '',
        tradeAmt: subcontractData?.subcontractSum ?? 0,
        revisedTradeAmt:
          subcontractData?.revisedSubcontractSum ??
          subcontractData?.subcontractSum ??
          0,
        tradeVoAmt: 0,
      };
    }
  };

  // ========== Construct Subcontract Details ==========
  const subcontractDetails = {
    '[subcontractCompanyName]':
      subcontractData?.subcontractorDetail?.name ?? '',
    '[subcontractRegistrationNo]':
      subcontractData?.subcontractorDetail?.registrationNo ?? '',
    '[subcontractAddress]': [
      // subcontractData?.subcontractorDetail?.name,
      subcontractData?.subcontractorDetail?.address?.address,
      subcontractData?.subcontractorDetail?.address?.postCode,
      subcontractData?.subcontractorDetail?.address?.city,
      subcontractData?.subcontractorDetail?.address?.state,
      subcontractData?.subcontractorDetail?.address?.country,
    ]
      .filter(Boolean)
      .join(', '),
    '[subcontractOfficeNo]':
      subcontractData?.subcontractorDetail?.contactNo ?? '',
    '[subcontractEmail]': subcontractData?.subcontractorDetail?.email ?? '',
    '[contractEndDate]': formatDate(subcontractData?.endDate) ?? '',
    '[createdBy]': subcontractData?.auditLog?.createdName ?? '',

    '[subcontractContactPerson]':
      subcontractData?.contactPerson?.[0]?.name ??
      subcontractData?.subcontractorDetail?.contactPerson?.[0]?.name ??
      subcontractData?.contact?.[0]?.name ??
      '',

    '[mainContractName]': subcontractData?.mainContractDetail?.title ?? '',
    '[mainContract]': subcontractData?.mainContractDetail?.title ?? '',

    '[projectAddress]': [
      subcontractData?.site?.name,
      subcontractData?.site?.address?.address,
      subcontractData?.site?.address?.postCode,
      subcontractData?.site?.address?.city,
      subcontractData?.site?.address?.state,
      subcontractData?.site?.address?.country,
    ]
      .filter(Boolean)
      .join(', '),

    '[subcontractTitle]': subcontractData?.title ?? '',
    '[subcontractNo]': subcontractData?.subcontractNo ?? '',
    '[subcontractAwardedDate]':
      formatDate(subcontractData?.subcontractDate) ?? '',
    '[creditTerm]': subcontractData?.creditTerm ?? '',
    '[description]': subcontractData?.description ?? '',
    '[termsConditions]': subcontractData?.termsConditions?.description ?? '',

    '[subcontractorName]': subcontractData?.subcontractorDetail?.name ?? '',

    '[subcontractorAddress]': [
      subcontractData?.subcontractorDetail?.address?.address,
      subcontractData?.subcontractorDetail?.address?.address,
      subcontractData?.subcontractorDetail?.address?.postCode,
      subcontractData?.subcontractorDetail?.address?.city,
      subcontractData?.subcontractorDetail?.address?.state,
      subcontractData?.subcontractorDetail?.address?.country,
    ]
      .filter(Boolean)
      .join(', '),
    '[contractContactPerson]': subcontractData?.contact?.[0]?.name ?? '',
    '[contractContactNo]': subcontractData?.contact?.[0]?.contactNo ?? '',
    '[subcontractorContactNo]':
      subcontractData?.contactPerson?.contactNo ??
      subcontractData?.subcontractorDetail?.contactPerson?.[0]?.contactNo ??
      subcontractData?.contact?.[0]?.contactNo ??
      '',

    '[subcontractorEmail]':
      subcontractData?.contactPerson?.[0]?.email ??
      subcontractData?.subcontractorDetail?.contactPerson?.[0]?.email ??
      subcontractData?.contact?.[0]?.email ??
      subcontractData?.subcontractorDetail?.email ??
      '',

    '[subcontractorRegNo]':
      subcontractData?.subcontractorDetail?.registrationNo ?? '',

    '[docNo]': previewDetail?.docNo ?? '',
    '[docDate]': formatDate(previewDetail?.docDate) ?? '',
    '[docRef]': previewDetail?.docRef ?? '',
    '[companyCurrencyCode]':
      loggedInUser?.companyCurrencyCode ?? companyDetails?.currencyCode ?? '',
    '[currency]': previewDetail?.currencyByDoc?.name ?? '',
    '[Currency]': previewDetail?.currencyByDoc?.name ?? '',
    '[currencyCode]': previewDetail?.currencyByDoc?.code ?? '',
    '[docAmt]': amtStr(previewDetail?.totalAmt),
  };

  // ========== Document Type Processing ==========
  switch (docType) {
    // =========================
    // SUBCONTRACT INFO
    // =========================
    case 'subcontract-info':
      // Get ALL trade data
      const allTradeData = subcontractData?.multipleTrade
        ? subcontractData?.subcontractCostWbs?.map((trade, index) => {
            const taxDetail = trade?.taxDetail;

            const taxRate =
              taxDetail?.taxSchemeDetails?.[0]?.taxSchemeDetailItems?.[0]?.tax
                ?.taxDetail?.[0]?.rate ?? 0;

            return {
              index: index + 1,
              name: trade?.costCategory?.name ?? '',
              tradeAmt: trade?.tradeAmt ?? 0,
              revisedTradeAmt: trade?.revisedTradeAmt ?? trade?.tradeAmt ?? 0,
              tradeVoAmt: trade?.tradeVoAmt ?? 0,
              taxCode: taxDetail?.name ?? '',
              taxRate: taxRate,
            };
          }) || []
        : [
            {
              index: 1,
              name: subcontractData?.tradeDetail?.name ?? '',
              tradeAmt: subcontractData?.subcontractSum ?? 0,
              revisedTradeAmt:
                subcontractData?.revisedSubcontractSum ??
                subcontractData?.subcontractSum ??
                0,
              tradeVoAmt: 0,
              taxCode: subcontractData?.taxDetail?.name ?? '',
              taxRate:
                subcontractData?.taxDetail?.taxSchemeDetails?.[0]
                  ?.taxSchemeDetailItems?.[0]?.tax?.taxDetail?.[0]?.rate ?? 0,
            },
          ];

      // Calculate totals for multiple trades
      const totalTradeAmt = allTradeData.reduce(
        (sum, trade) => sum + (trade.tradeAmt || 0),
        0,
      );
      const totalRevisedTradeAmt = allTradeData.reduce(
        (sum, trade) => sum + (trade.revisedTradeAmt || 0),
        0,
      );
      const totalTradeVoAmt = allTradeData.reduce(
        (sum, trade) => sum + (trade.tradeVoAmt || 0),
        0,
      );

      // CX-5564: sum after tax params
      const totalTaxAmt = allTradeData.reduce(
        (sum, trade) =>
          sum + ((trade.revisedTradeAmt || 0) * (trade.taxRate || 0)) / 100,
        0,
      );
      const sumAfterTax = totalRevisedTradeAmt + totalTaxAmt;

      if (subcontractData?.multipleTrade && allTradeData.length > 1) {
        const formattedTradeNames = allTradeData
          .map(trade => `${trade.index}. ${trade.name}`)
          .join('<br/>');

        const primaryTax = allTradeData[0];

        return Object.assign(paramVal, subcontractDetails, {
          '[index]': '1',
          '[tradeName]': formattedTradeNames,
          '[tradeAmt]': amtStr(totalTradeAmt),
          '[tradeTotalAmt]': amtStr(totalRevisedTradeAmt),
          '[tradeVoAmt]': amtStr(totalTradeVoAmt),
          '[taxCode]': primaryTax.taxCode,
          '[taxRate]': primaryTax.taxRate.toString(),

          '[preparedBy]':
            subcontractData?.auditLog?.createdName ??
            previewDetail?.generatedBy ??
            '',
          '[totalAmtInWords]': moneyFunction(
            subcontractData?.revisedSubcontractSum ??
              subcontractData?.subcontractSum ??
              0,
          ),
          '[subcontractSum]': amtStr(totalTradeAmt),
          '[revisedSubcontractSum]': amtStr(totalRevisedTradeAmt),
          '[taxAmt]': amtStr(totalTaxAmt),
          '[sumTaxAmt]': amtStr(totalTaxAmt),
          '[subcontractSumAfterTax]': amtStr(sumAfterTax),
          '[subcontractSumAfterTaxInWords]': moneyFunction(sumAfterTax),
        });
      } else {
        const tradeData = allTradeData[0];
        return Object.assign(paramVal, subcontractDetails, {
          '[index]': tradeData.index.toString(),
          '[tradeName]': tradeData.name,
          '[tradeAmt]': amtStr(tradeData.tradeAmt),
          '[tradeTotalAmt]': amtStr(tradeData.revisedTradeAmt),
          '[tradeVoAmt]': amtStr(tradeData.tradeVoAmt),
          '[taxCode]': tradeData.taxCode,
          '[taxRate]': tradeData.taxRate.toString(),

          '[preparedBy]':
            subcontractData?.auditLog?.createdName ??
            previewDetail?.generatedBy ??
            '',
          '[totalAmtInWords]': moneyFunction(
            subcontractData?.revisedSubcontractSum ??
              subcontractData?.subcontractSum ??
              0,
          ),
          '[subcontractSum]': amtStr(subcontractData?.subcontractSum ?? 0),
          '[revisedSubcontractSum]': amtStr(
            subcontractData?.revisedSubcontractSum ??
              subcontractData?.subcontractSum ??
              0,
          ),
          '[taxAmt]': amtStr(totalTaxAmt),
          '[sumTaxAmt]': amtStr(totalTaxAmt),
          '[subcontractSumAfterTax]': amtStr(sumAfterTax),
          '[subcontractSumAfterTaxInWords]': moneyFunction(sumAfterTax),
        });
      }
    default:
      return paramVal;
  }
};
